import { IconSvg, IconSvgProps } from "./icon"

export default function Pause(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <rect x="4.875" y="4.5" width="4.5" height="15" rx="1.4" />
      <rect x="14.625" y="4.5" width="4.5" height="15" rx="1.4" />
    </IconSvg>
  )
}
